/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu May 12 2021 04:30:00 PM
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { routes } from 'src/routes';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import Notification from 'src/components/containers/dashboard/notifications/notification';

type Props = {
  subscription: Object
};

type ComposedProps = Props & WithI18nProps;

const ExceededPlanNotification: React.FC<ComposedProps> = ({ subscription, i18n }) => {
  const { status, isFirst7Days } = subscription;
  if (status === 'exceededWithNotification') {
    const content = isFirst7Days
      ? i18n.translate('AdminHTML.Common.ExceededPlanNotification.content1', {
          nt_new_line_character: '<br/>',
          t: `<strong>${i18n.translate(
            'AdminHTML.Common.ExceededPlanNotification.content1_t'
          )}</strong>`
        })
      : i18n.translate('AdminHTML.Common.ExceededPlanNotification.content2', {
          nt_new_line_character: '<br/>',
          t: `<strong>${i18n.translate(
            'AdminHTML.Common.ExceededPlanNotification.content2_t'
          )}</strong>`
        });

    const notification = {
      type: 'warning',
      allowDismiss: false,
      title: i18n.translate('AdminHTML.Common.ExceededPlanNotification.title'),
      content,
      actionLabel: i18n.translate('AdminHTML.Common.ExceededPlanNotification.actionLabel'),
      action: routes.subscription.plan(),
      secondaryActionLabel: i18n.translate(
        'AdminHTML.Common.ExceededPlanNotification.secondaryActionLabel'
      ),
      secondaryAction:
        'https://help.boostcommerce.net/article/423-what-exactly-counts-as-a-product#new3'
    };
    return (
      <div className="exceededPlanNotification">
        <Notification status={notification.type} notification={notification} />
      </div>
    );
  }
  return null;
};

const mapStateToProps = state => ({
  subscription: _.get(state.oauth, 'subscription', {})
});

export default connect(mapStateToProps)(withI18n()(ExceededPlanNotification));
